import { TimeStampsData } from './jsonSchema.utils';

export const enum AdminPopupDisplayFrequencyDaysEnum {
  weekly = 'weekly',
  daily = 'daily',
  once = 'once',
}

export const enum AdminPopupImageEnum {
  ear = 'ear',
  heart = 'heart',
  sos = 'sos',
  thumbsUp = 'thumbsUp',
  trophy = 'trophy',
}

export interface AdminPopup extends TimeStampsData {
  id: number;
  from: string | null;
  name: string;
  to: string | null;
  display_frequency: AdminPopupDisplayFrequencyDaysEnum;
  display_frequency_weekday: number[] | null;
  button_text: string | null;
  image: AdminPopupImageEnum;
  button_url: string | null;
  content: string;
  company_ids: number[];
  show_on_modul_page: string[];
}
